module.exports = __webpack_public_path__ + "img/facebook_colored.a4c413b.svg";